var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartingMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9327,
    cy: 17.9327,
    r: 17.4327,
    fill: "#219653",
    stroke: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9325 19.1898C17.8068 19.1898 17.6811 19.1608 17.565 19.0931L9.02678 14.1519C8.67868 13.9489 8.56262 13.504 8.76569 13.1559C8.96875 12.8078 9.40388 12.6918 9.76165 12.8948L17.9325 17.6233L26.0549 12.9239C26.4031 12.7208 26.8479 12.8465 27.0509 13.185C27.254 13.5331 27.1283 13.9778 26.7898 14.1809L18.3096 19.0931C18.1839 19.1511 18.0582 19.1898 17.9325 19.1898Z",
    fill: "#D8DEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9327 27.9512C17.5363 27.9512 17.2075 27.6225 17.2075 27.226V18.4557C17.2075 18.0592 17.5363 17.7305 17.9327 17.7305C18.3292 17.7305 18.658 18.0592 18.658 18.4557V27.226C18.658 27.6225 18.3292 27.9512 17.9327 27.9512Z",
    fill: "#D8DEF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9327 28.3287C17.0818 28.3287 16.2406 28.145 15.5734 27.7775L10.4098 24.9057C9.00769 24.1321 7.91504 22.2659 7.91504 20.6607V15.1974C7.91504 13.5922 9.00769 11.7357 10.4098 10.9525L15.5734 8.09023C16.8981 7.35534 18.9674 7.35534 20.2921 8.09023L25.4557 10.9621C26.8578 11.7356 27.9504 13.6019 27.9504 15.207V20.6704C27.9504 22.2756 26.8578 24.1321 25.4557 24.9153L20.2921 27.7775C19.6249 28.145 18.7837 28.3287 17.9327 28.3287ZM17.9327 8.9895C17.3236 8.9895 16.724 9.11521 16.2792 9.35695L11.1157 12.2288C10.1874 12.7509 9.36548 14.1337 9.36548 15.207V20.6704C9.36548 21.7341 10.1874 23.1264 11.1157 23.6486L16.2792 26.5205C17.1592 27.0136 18.7063 27.0136 19.5862 26.5205L24.7498 23.6486C25.6781 23.1264 26.5 21.7437 26.5 20.6704V15.207C26.5 14.1434 25.6781 12.7509 24.7498 12.2288L19.5862 9.35695C19.1414 9.11521 18.5419 8.9895 17.9327 8.9895Z",
    fill: "#D8DEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7677 19.8583C22.3712 19.8583 22.0425 19.5295 22.0425 19.1331V16.0195L13.2238 10.9333C12.8757 10.7302 12.7596 10.2854 12.9627 9.94695C13.1658 9.59884 13.6009 9.48279 13.949 9.68585L23.1255 14.9848C23.3479 15.1105 23.4929 15.3522 23.4929 15.6133V19.1524C23.4929 19.5295 23.1642 19.8583 22.7677 19.8583Z",
    fill: "#D8DEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartingMark);
export default __webpack_public_path__ + "static/media/starting_mark.c247ff0a868dd63b92c4afca00632fc0.svg";
export { ForwardRef as ReactComponent };